import { Injectable } from '@angular/core';
import { LoadingController, ToastController } from '@ionic/angular/standalone';
import { StorageService } from './storage.service';
import { Share } from '@capacitor/share';
import { LocalNotifications, ScheduleOptions } from '@capacitor/local-notifications';
import { AlertService } from './alert-service.service';
import { URL, OLDURL} from './config';
//import { Router } from '@angular/router';
//import { RestService } from './rest.service';
@Injectable({
  providedIn: 'root'
})
export class HelperService {

  public load: any;
  private email: string = '';
  private password: string = '';
  notifiPermission: boolean = false;

  constructor(
    private loading: LoadingController,
    private toastController: ToastController,
    private storage: StorageService,
    private alert: AlertService,
    //private route: Router,
    //private rest: RestService
  ) {
    this.load = this.loading.create({

    });
    console.log('spinner created')
  }
  public async startSpiner(mess?:string,){
    let message = '';
    if (mess){message = mess} 
    this.load = await this.loading.create({
      message: message,
      //duration: 3000,
    });

    this.load.present();
  }
  public async clearSpinners(){
    await this.load.dismiss();
  }
  public async toastTop(message: string, delay:number){
    const toast = await this.toastController.create({
      message: message,
      duration: delay,
      position: 'top',
    });

    await toast.present();
  }
  public async toastMid(message: string, delay:number){
    const toast = await this.toastController.create({
      message: message,
      duration: delay,
      position: 'middle',
    });

    await toast.present();
  }
  public async toastBottom(message: string, delay:number){
    const toast = await this.toastController.create({
      message: message,
      duration: delay,
      position: 'bottom',
    });

    await toast.present();
  }
  public async toastDissmiss(){
    await this.toastController.dismiss();
  }
  public async getConfig(val:string){
    let config = this.storage.config.find( ({name}) => name === val);
    if(config){ return config.data1;}
    else {return null}
  }
  public async checkNotifiPermission(){
    if(!this.notifiPermission)    {
      LocalNotifications.checkPermissions().then(async(res)=>{
        console.log('Notifi permission: ', res.display);
        if(res.display === 'granted'){
          this.notifiPermission = true;
          return true;
        }
        else{
          LocalNotifications.requestPermissions().then(async(res)=>{
            console.log('Notifi permission req: ', res.display);
            if(res.display === 'granted'){
              this.notifiPermission = true;
              return true;
            }
            else{
              alert('Notification permission not requested');
              return false;
            }
          });
        }
        return false;
      });
      return false;
    }
    else{
      return true;
    }
  }
  public async notification(message:{id?:number, title:string, body:string, scheduleAt?:Date, repeatsW?:boolean, link?:string, actionTypeId?:string}){
    if(!this.notifiPermission)    {
      if(await this.checkNotifiPermission()){
      }
      else{
        // alert('Notification permission denied');
        // return;
      }
    }
    
      let options:ScheduleOptions={
        notifications:[
          {
            id:message.id?message.id : Math.floor(Math.random() * 1000) + 111,
            title: message.title,
            body: message.body,
            schedule: { 
              at: message.scheduleAt ? message.scheduleAt : new Date(Date.now()), 
              repeats: message.repeatsW ? true : false,
              every: message.repeatsW ? 'week' : undefined,
              allowWhileIdle: true,              
            },
            extra: {
              link: message.link ? message.link : null      
            },
            actionTypeId: message.actionTypeId ? message.actionTypeId : undefined,
                        //iconColor: #fffff,
          }
        ]
      }
      try{
        LocalNotifications.schedule(options).then(async ()=>{
          console.log('Notification scheduled: ' + JSON.stringify(options)); //is driven ok
          // this.alert.info('Notification scheduled: ' + JSON.stringify(options));
        });
      }
      catch(ex){
        alert(JSON.stringify(ex));
      }
    
  }
  public fixUrl(url:string){
    if(url && url.startsWith(OLDURL)){
      return url.replace(OLDURL, URL);
    }
    return url;
  }
}
